<template>
  <v-container id="usuariosform" tag="section">
    <base-v-component :heading="'Usuario ' + usuario.displayName" />
    <base-material-card
      color="indigo"
      icon="mdi-account"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="save"
          :loading="loading"
          >Guardar</v-btn
        >
        <v-spacer />
        <v-btn color="primary" dark class="mb-2" @click="goVerPedidos"
          >Ver pedidos</v-btn
        >
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="ID Usuario"
                rounded
                outlined
                v-model="usuario.id"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="Nombre"
                rounded
                outlined
                v-model="usuario.displayName"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="Telefono"
                rounded
                outlined
                v-model="usuario.phoneNumber"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="Email"
                rounded
                outlined
                v-model="usuario.email"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="Canal registro"
                rounded
                outlined
                v-model="usuario.canalRegistro"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="Rol"
                rounded
                outlined
                v-model="usuario.role"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                readonly
                label="Negocios"
                rounded
                outlined
                v-model="usuario.negocios"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                readonly
                label="Restaurantes"
                rounded
                outlined
                v-model="usuario.restaurantes"
              />
            </v-col>
            <v-col cols="12">
              <h5>Direcciones entrega</h5>
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="(dir, i) in usuario.direcciones"
                  :key="i"
                >
                  <v-expansion-panel-header>
                    {{ dir.calle }}, {{ dir.municipio }}, {{ dir.provincia }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense no-gutters>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Calle"
                          rounded
                          v-model="dir.calle"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Municipio"
                          rounded
                          v-model="dir.municipio"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Provincia"
                          rounded
                          v-model="dir.provincia"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Código Postal"
                          rounded
                          v-model="dir.cp"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-if="Array.isArray(dir.coordenadas)"
                          label="Latitud"
                          rounded
                          v-model="dir.coordenadas[0]"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-if="Array.isArray(dir.coordenadas)"
                          label="Longitud"
                          rounded
                          v-model="dir.coordenadas[1]"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-if="dir.lastUse"
                          readonly
                          label="Último uso"
                          rounded
                          :value="dir.ultimoUso"
                        /> </v-col
                    ></v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="12">
              <h5>Direcciones facturación</h5>
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="(dir, i) in usuario.direccionesFacturacion"
                  :key="i"
                >
                  <v-expansion-panel-header>
                    {{ dir.nombre }} | {{ dir.dir1 }}, {{ dir.municipio }},
                    {{ dir.provincia }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense no-gutters>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Calle"
                          rounded
                          v-model="dir.dir1"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Municipio"
                          rounded
                          v-model="dir.municipio"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Provincia"
                          rounded
                          v-model="dir.provincia"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Código Postal"
                          rounded
                          v-model="dir.cp"
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="CIF" rounded v-model="dir.cif" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          label="Nombre"
                          rounded
                          v-model="dir.nombre"
                        /> </v-col
                    ></v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </base-material-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      usuarioBruto: (state) => state.users.usuarioViendo,
    }),
    usuario() {
      if (this.usuarioBruto) {
        return {
          ...this.usuarioBruto,
          direcciones: this.usuarioBruto.direcciones
            ? this.usuarioBruto.direcciones.map((d) => {
                return {
                  ...d,
                  ultimoUso: moment(d.lastUse.toDate()).format(
                    "HH:mm DD-MM-YYYY"
                  ),
                };
              })
            : [],
        };
      } else {
        return {
          id: null,
          restaurantes: [],
          negocios: [],
          direcciones: [],
          displayName: "",
        };
      }
    },
  },
  methods: {
    save() {
      this.usuario.direcciones = this.usuario.direcciones.map((d) => {
        return {
          ...d,
          coordenadas: d.coordenadas.map((c) => parseFloat(c)),
        };
      });
      this.loading = true;
      this.$store
        .dispatch("users/changePerfilUserAdmin", this.usuario)
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Copia eliminada",
          });
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido cambiar el usuario " + e,
          });
        })
        .finally(() => {
          this.loading = false;
          this.getUser();
        });
    },
    getUser() {
      this.$store
        .dispatch("users/getUsuario", this.$route.params.idusuario)
        .catch((e) => {
          console.log(e);
          this.$router.push("/admin/panel");
        });
    },
    goVerPedidos() {
      this.$router.push("/admin/usuario/" + this.usuario.id + "/pedidos");
    },
  },
  mounted() {
    // this.usuario.id = this.$route.params.idusuario;
    if (this.$route.params.idusuario) {
      this.getUser();
    } else {
      this.$router.push("/admin/panel");
    }
  },
};
</script>

<style>
</style>